import logo from "assets/tea-logo.png";
import { Button } from "react-bootstrap";
import { Trans, useTranslation } from "react-i18next";

function ErrorPage() {
  const { t } = useTranslation("Shared");
  return (
    <div
      id="full"
      className="d-flex flex-column justify-content-center align-items-center"
    >
      <img
        src={logo}
        alt="Travel & Expenses Assistant Logo"
        style={{
          width: "200px",
          height: "200px",
        }}
        className="my-3 animate"
      />
      <div className="d-flex flex-column text-center">
        <span className="mx-5 mb-3 mt-0">
          <Trans i18nKey="unexpected_error" ns="Shared">
            An unexpected error occured. <br />
            Please raise a ticket via
            <a
              className="fw-bolder"
              target="_blank"
              href="https://dsv.service-now.com/esc"
            >
              Service Now
            </a>
            <br />
            Your report will help us improve the application.
          </Trans>
        </span>

        <Button
          onClick={() => (window.location.href = "/")}
          className="align-self-center"
        >
          {t("buttons.return_to_home_page")}
        </Button>
      </div>
    </div>
  );
}

export default ErrorPage;
